export default __webpack_public_path__ + "static/tooltip-interactive-2-dont-light-4e9c4fa322d8be5acc8636aee0e2c2662f9b10a9fb9ecaa862dd21bbf626b0be.png";